import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pn-checkbox',
  templateUrl: './pn-checkbox.component.html',
  styleUrls: ['./pn-checkbox.component.scss'],
})
export class PnCheckboxComponent implements OnInit {
  @Input() public id;
  @Input() public type;
  @Input() public name;
  @Input() public label;
  @Input() public value;
  @Input() public control;
  @Input() public disabled;
  @Input() public checked;
  @Input() public error;

  ngOnInit() {}
}
